/**
 * 全局配置文件
 */
export default {
  // 配置首页不可关闭
  isFirstPage: false,
  fistPage: {
    label: '解码概览',
    value: '/',
    params: {},
    query: {},
    meta: {
      i18n: 'dashboard'
    },
    group: [],
    close: false
  },
  // 配置菜单的属性
  menu: {
    iconDefault: 'iconfont icon-caidan',
    props: {
      label: 'name',
      path: 'path',
      icon: 'source',
      children: 'children'
    }
  }
}
